

<nz-alert
  *ngIf="data.status !== 'Disabled'"
  [nzType]="data.status === 'Sent' ? 'success' : data.status === 'Failed' ? 'error' : data.status === 'Busy' || data.status === 'Pending' ? 'info' : 'info'"
  [nzMessage]="data.status"
  [nzDescription]="data.errorMessage??''"
  nzShowIcon>
</nz-alert>
<div *ngIf="data.type == 'Email'" class="email-view mt-2">
		<!-- Headers -->
		<nz-descriptions [nzColumn]="1" nzBordered nzSize="small">

			<nz-descriptions-item nzTitle="From">
				<nz-tag nzColor="blue">{{ data.emailFrom }}</nz-tag>
			</nz-descriptions-item>

			<nz-descriptions-item nzTitle="To">
				<nz-tag *ngFor="let addr of split(data.emailTo)" nzColor="green">{{ addr }}</nz-tag>
			</nz-descriptions-item>

			<nz-descriptions-item nzTitle="CC" *ngIf="data.emailCc?.length">
				<nz-tag *ngFor="let addr of split(data.emailCc)">{{ addr }}</nz-tag>
			</nz-descriptions-item>

			<nz-descriptions-item nzTitle="BCC" *ngIf="data.emailBcc?.length">
				<nz-tag *ngFor="let addr of split(data.emailBcc)" nzColor="orange">{{ addr }}</nz-tag>
			</nz-descriptions-item>

			<nz-descriptions-item nzTitle="Subject">
				<strong>{{ data.emailSubject }}</strong>
			</nz-descriptions-item>

		</nz-descriptions>

		<!-- HTML Body -->
		<nz-divider nzText="Body" nzOrientation="left"></nz-divider>
		<div class="email-body" [innerHTML]="data.emailBody"></div>

		<!-- Attachments -->
		<ng-container *ngIf="data.attachments?.length">
			<nz-divider nzText="Attachments" nzOrientation="left"></nz-divider>
			<div class="attachments">
				<div class="attachment-item" *ngFor="let attachment of data.attachments">
					<ng-container *ngIf="!canPreview(attachment)">
						<span nz-icon nzType="paper-clip" nzTheme="outline"></span>
						<span class="attachment-name">{{ attachment.fileName }}</span>
					</ng-container>
					<!-- <a [href]="attachment.downloadUrl" download>
						<button nz-button nzType="link" nzSize="small">
							<span nz-icon nzType="download" nzTheme="outline"></span>
							Download
						</button>
					</a> -->
					<button nz-button *ngIf="canPreview(attachment)" [nzType]="'dashed'" (click)="doPreviewFile(attachment)" class="me-2">
						<span nz-icon nzType="eye"></span>
						<span class="attachment-name">{{ attachment.fileName }}</span>
					</button>
				</div>
			</div>
		</ng-container>
</div>
<div *ngIf="data.type == 'Sms'" class="email-view mt-2">
		<nz-descriptions [nzColumn]="1" nzBordered nzSize="small">

			<nz-descriptions-item nzTitle="To">
				<nz-tag nzColor="blue">{{ data.smsMsisdn }}</nz-tag>
			</nz-descriptions-item>

			<nz-descriptions-item nzTitle="Message">
				<strong>{{ data.smsMessage }}</strong>
			</nz-descriptions-item>
		</nz-descriptions>
</div>
